// O material abre sempre em uma janela popup propria: a pagina do material se fecha
// sozinha quando o timer da aula termina, entao ela nao pode ocupar a aba do dashboard.
const POPUP_FEATURES = 'popup,width=1080,height=660, left=300, top=500';

// `lessonId` e opcional porque a mesma janela serve para abrir o book inteiro (portal,
// onde a lista de lessons e o ponto de partida) e para abrir uma lesson especifica.
export function abrirMaterialDoBook(bookId: string, lessonId?: string) {
	const url = lessonId
		? `/dashboard/materiais/${bookId}?lesson=${encodeURIComponent(lessonId)}`
		: `/dashboard/materiais/${bookId}`;
	window.open(url, '', POPUP_FEATURES);
}
